export enum QuestionType {
  SingleChoice = 'SINGLE_CHOICE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  TrueOrFalse = 'TRUE_OR_FALSE',
  Subjective = 'SUBJECTIVE'
}
